import React from 'react';
import { LoaderCircle } from 'lucide-react';
import './Spinner.scss';

export interface SpinnerProps {
  /** Size of the spinner in pixels (default: 20) */
  size?: number;
  /** Color of the spinner (default: 'currentColor') */
  color?: string;
  /** Additional CSS class names */
  className?: string;
}

/**
 * Reusable Spinner component with rotating animation
 * Uses LoaderCircle from lucide-react
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <LoaderCircle
      size={size}
      color={color}
      className={`spinner ${className}`}
    />
  );
};

export default Spinner;
